@if(type !== 'default') {
  <div
    [class.e-avatar-border]="border && type !== 'profile'"
    [class.m-1]="padding && type === 'xxs'"
    [class.avatar-clickable]="canOpenProfile()"
    [attr.role]="canOpenProfile() ? 'button' : null"
    [attr.tabindex]="canOpenProfile() ? 0 : null"
    [class]="containerClasses"
    (click)="onAvatarClick($event)">
    @if(image) {
      @if (disableImageOptimization) {
        <img [alt]="name" [height]="height" [width]="width" [src]="image" (error)="onImageError()" [class.avatar-inactive]="inactive"/>
      } @else {
        <img [alt]="name" [height]="height" [width]="width" [ngSrc]="image" [sizes]="'100vw'" [priority]="false" [disableOptimizedSrcset]="false" (error)="onImageError()" [class.avatar-inactive]="inactive"/>
      }
    } @else {
      <span [class]="defaultIconClasses">{{ icon }}</span>
    }
  </div>
} @else {
  <div
    class="d-flex align-items-center"
    [class.avatar-clickable]="canOpenProfile()"
    [attr.role]="canOpenProfile() ? 'button' : null"
    [attr.tabindex]="canOpenProfile() ? 0 : null"
    (click)="onAvatarClick($event)">
    <div [class.e-avatar-border]="border" [class]="containerClasses">
      @if (image) {
        @if (disableImageOptimization) {
          <img [alt]="name" [height]="height" [width]="width" [src]="image" (error)="onImageError()" [class.avatar-inactive]="inactive"/>
        } @else {
          <img [alt]="name" [height]="height" [width]="width" [ngSrc]="image" [sizes]="'100vw'" [priority]="false" [disableOptimizedSrcset]="false" (error)="onImageError()" [class.avatar-inactive]="inactive"/>
        }
      } @else {
        <span [class]="defaultIconClasses">{{ icon }}</span>
      }
    </div>

    <div class="d-flex flex-column">
      <app-headline [title]="name" [type]="'h6'" [class]="'text-primary fs-small'" ></app-headline>
      <app-content [fontSize]="'fs-verysmall'" [class]="'d-block'">{{ subTitle }}</app-content>

      <span class="d-block e-avatar-lh">
        @if (editDate) {
          <app-content [fontDecoration]="'fw-bold'" [fontSize]="'fs-verysmall'" [class]="'me-1'">{{ 'EDITED' | translate }}</app-content>
        }
        <app-content [fontSize]="'fs-verysmall'">{{ (editDate ? editDate : date) | timePast }}</app-content>
      </span>
    </div>
  </div>
}
